import React from 'react';
import {Box} from '@mui/material';
import {Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface Props {
  testID?: string;
  titleLocaleKey: string;
}

function TabsHeader({testID = 'tabs-header', titleLocaleKey}: Props) {
  return (
    <Box data-testid={testID}>
      <Headline size="sm">{translate(titleLocaleKey)}</Headline>
    </Box>
  );
}

export default TabsHeader;
